class StarSignDetailsModel {
    dateOfBirth: Date;
    latitude: number;
    longitude: number;
}

export {StarSignDetailsModel}